import React from 'react'
import useTranslation from 'next-translate/useTranslation'
import { Layout } from 'components/Layout'
import { Header } from 'components/Header'
import { RecipesRoot } from './Recipes.styles'
import { Hero } from './Overview/components/Hero'
import { SelectRecipe } from './Overview/components/SelectRecipes'
import hero from '../../../public/assets/recipes/overview/frozen/frozen-raw-recipe-hero.webp'
import { FeedBetter } from './Overview/components/FeedBetter'
import { ReviewSlider } from 'features/components/ReviewSlider'
import { DoBetter } from '../WhyWeFeedRaw/components/DoBetter'
import { CtaFooter } from 'features/Home/components/CtaFooter'
import { Footer } from 'components/Footer'
import { MadeRight } from './Overview/components/MadeRight/MadeRight'
import { FloatingCta } from './Overview/components/FloatingCta'

export const Recipes = () => {
  const { t } = useTranslation()
  const header = <Header />

  return (
    <RecipesRoot>
      <Layout hideCTA header={header}>
        <Hero
          title={t('recipes-overview:hero.frozen.title')}
          subtitle={t('recipes-overview:hero.frozen.subtitle')}
          heroImage={hero}
          imageAlt={t('recipes-overview:hero.frozen.image-alt')}
        />
        <SelectRecipe type="frozen" />
        <MadeRight type="frozen" />
        <DoBetter compare={true} />
        <ReviewSlider color="accent-black" background="tertiary-200" hideCTA recipePage={true} />
        <FeedBetter showFrozen={false} showFreezeDried={true} />
        <CtaFooter title="why-we-feed-raw:footer.title" hideSecondaryCta />
        <FloatingCta />
        <Footer />
      </Layout>
    </RecipesRoot>
  )
}

Recipes.displayName = 'Recipes'
